function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SegmentNodeList from './SegmentNodeList';
import WKTWriter from '../io/WKTWriter';
import CoordinateArraySequence from '../geom/impl/CoordinateArraySequence';
import Coordinate from '../geom/Coordinate';
import Octant from './Octant';
import ArrayList from '../../../../java/util/ArrayList';
import NodableSegmentString from './NodableSegmentString';
var NodedSegmentString = /*#__PURE__*/function () {
  function NodedSegmentString() {
    _classCallCheck(this, NodedSegmentString);
    NodedSegmentString.constructor_.apply(this, arguments);
  }
  return _createClass(NodedSegmentString, [{
    key: "getCoordinates",
    value: function getCoordinates() {
      return this._pts;
    }
  }, {
    key: "size",
    value: function size() {
      return this._pts.length;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate(i) {
      return this._pts[i];
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      return this._pts[0].equals(this._pts[this._pts.length - 1]);
    }
  }, {
    key: "getSegmentOctant",
    value: function getSegmentOctant(index) {
      if (index === this._pts.length - 1) return -1;
      return this.safeOctant(this.getCoordinate(index), this.getCoordinate(index + 1));
    }
  }, {
    key: "setData",
    value: function setData(data) {
      this._data = data;
    }
  }, {
    key: "safeOctant",
    value: function safeOctant(p0, p1) {
      if (p0.equals2D(p1)) return 0;
      return Octant.octant(p0, p1);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this._data;
    }
  }, {
    key: "addIntersection",
    value: function addIntersection() {
      if (arguments.length === 2) {
        var intPt = arguments[0];
        var segmentIndex = arguments[1];
        this.addIntersectionNode(intPt, segmentIndex);
      } else if (arguments.length === 4) {
        var li = arguments[0];
        var _segmentIndex = arguments[1];
        var geomIndex = arguments[2];
        var intIndex = arguments[3];
        var _intPt = new Coordinate(li.getIntersection(intIndex));
        this.addIntersection(_intPt, _segmentIndex);
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      return WKTWriter.toLineString(new CoordinateArraySequence(this._pts));
    }
  }, {
    key: "getNodeList",
    value: function getNodeList() {
      return this._nodeList;
    }
  }, {
    key: "addIntersectionNode",
    value: function addIntersectionNode(intPt, segmentIndex) {
      var normalizedSegmentIndex = segmentIndex;
      var nextSegIndex = normalizedSegmentIndex + 1;
      if (nextSegIndex < this._pts.length) {
        var nextPt = this._pts[nextSegIndex];
        if (intPt.equals2D(nextPt)) {
          normalizedSegmentIndex = nextSegIndex;
        }
      }
      var ei = this._nodeList.add(intPt, normalizedSegmentIndex);
      return ei;
    }
  }, {
    key: "addIntersections",
    value: function addIntersections(li, segmentIndex, geomIndex) {
      for (var i = 0; i < li.getIntersectionNum(); i++) {
        this.addIntersection(li, segmentIndex, geomIndex, i);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return NodedSegmentString;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [NodableSegmentString];
    }
  }], [{
    key: "getNodedSubstrings",
    value: function getNodedSubstrings() {
      if (arguments.length === 1) {
        var segStrings = arguments[0];
        var resultEdgelist = new ArrayList();
        NodedSegmentString.getNodedSubstrings(segStrings, resultEdgelist);
        return resultEdgelist;
      } else if (arguments.length === 2) {
        var _segStrings = arguments[0];
        var _resultEdgelist = arguments[1];
        for (var i = _segStrings.iterator(); i.hasNext();) {
          var ss = i.next();
          ss.getNodeList().addSplitEdges(_resultEdgelist);
        }
      }
    }
  }]);
}();
export { NodedSegmentString as default };
NodedSegmentString.constructor_ = function () {
  this._nodeList = new SegmentNodeList(this);
  this._pts = null;
  this._data = null;
  var pts = arguments[0];
  var data = arguments[1];
  this._pts = pts;
  this._data = data;
};